import React from 'react'

import { MobXProviderContext, observer } from 'mobx-react'

import DesktopInitialState from '~/client/src/desktop/stores/DesktopInitialState'
import ProjectSetupResourceProperties from '~/client/src/desktop/views/ProjectSetUp/components/ProjectSetupResourceConfig/ResourceProperties/ProjectSetupResourceProperties'
import { ResourceTypeId } from '~/client/src/shared/constants/resourceTypes'
import { LocalStorageKey } from '~/client/src/shared/enums/LocalStorageKey'
import { useEquipmentResourceStore } from '~/client/src/shared/hooks/useEquipmentResourceStore'

function EquipmentProperties(): React.ReactElement {
  const { state } = React.useContext(MobXProviderContext) as {
    state: DesktopInitialState
  }
  const { schema } = useEquipmentResourceStore(state.activeProject?.id)

  return (
    <ProjectSetupResourceProperties
      resourceTypeId={ResourceTypeId.OFFLOADING_EQUIPMENT}
      columnConfigKey={LocalStorageKey.EquipmentPropertiesColumnConfig}
      resourceSchema={schema}
    />
  )
}

export default observer(EquipmentProperties)
